module.exports = __webpack_public_path__ + "static/media/blog4-image.26e66505.jpg";